import { createI18n } from 'vue-i18n'

import zhLocale from 'element-plus/es/locale/lang/zh-cn'
import enLocale from 'element-plus/es/locale/lang/en'
import zhhantLocale from 'element-plus/es/locale/lang/zh-tw'
import heLocale from 'element-plus/es/locale/lang/he'
import deLocale from 'element-plus/es/locale/lang/de'
import esLocale from 'element-plus/es/locale/lang/es'
import ruLocale from 'element-plus/es/locale/lang/ru'
import viLocale from 'element-plus/es/locale/lang/vi'

import { useI18n } from 'vue-i18n'
import elementZhCn from 'element-plus/es/locale/lang/zh-cn'
import elementEn from 'element-plus/es/locale/lang/en'

// import schemaTextZh from '@/schemaText/schema-text-zh.json'
// import schemaTextEn from '@/schemaText/schema-text-en.json'
// import symbolLabelZh from '@/schemaText/symbol-label-zh.json'
// import symbolLabelEn from '@/schemaText/symbol-label-en.json'
// import actionText from '@/schemaText/actionText/index'

import { get } from 'lodash'
import { useStore } from 'vuex'
import { ref } from 'vue'
const store = useStore()

const lang: { [key: string]: any } = {
  en: {
    ...enLocale,
  },
  zh_cn: {
    ...zhLocale,
  },
  zhhant: {
    ...zhhantLocale,
  },
  he: {
    ...heLocale,
  },
  de: {
    ...deLocale,
  },
  es: {
    ...esLocale,
  },
  ru: {
    ...ruLocale,
  },
  vi: {
    ...viLocale,
  },
}
const translations = require.context('./i18n', false, /\.js$/)
Array.prototype.forEach.call(translations.keys(), (path) => {
  const tran = translations(path).default
  const partKey = path.match(/\w+/)[0] //retrieve the filename as partial keys
  lang.en[partKey] = lang.en[partKey] || {}
  lang.zh_cn[partKey] = lang.zh_cn[partKey] || {}
  lang.zhhant[partKey] = lang.zhhant[partKey] || {}
  lang.he[partKey] = lang.he[partKey] || {}
  lang.de[partKey] = lang.de[partKey] || {}
  lang.es[partKey] = lang.es[partKey] || {}
  lang.ru[partKey] = lang.ru[partKey] || {}
  lang.vi[partKey] = lang.vi[partKey] || {}
  Object.keys(tran).forEach((k) => {
    const { en, zh_cn, zhhant, he, de, es, ru, vi } = tran[k]
    lang.en[partKey][k] = en
    lang.zh_cn[partKey][k] = zh_cn
    lang.zhhant[partKey][k] = zhhant
    lang.he[partKey][k] = he
    lang.de[partKey][k] = de
    lang.es[partKey][k] = es
    lang.ru[partKey][k] = ru
    lang.vi[partKey][k] = vi
  })
})

// lang.en.ConfigSchema = schemaTextEn
// lang.zh.ConfigSchema = schemaTextZh
// lang.en.BridgeSchema = actionText.en
// lang.zh.BridgeSchema = actionText.zh
// lang.en.SchemaSymbolLabel = symbolLabelEn
// lang.zh.SchemaSymbolLabel = symbolLabelZh

const language = localStorage.getItem('language') || 'zh_cn'
const i18nInstance = createI18n({
  messages: lang,
  locale: language,
  warnHtmlInMessage: 'off',
})

export const getLocalMessage = (path: string): string => {
  const local = i18nInstance.global.locale
  const messages = i18nInstance.global.messages[local]
  return get(messages, path)
}

export default i18nInstance
